import { createReducer, on } from '@ngrx/store';
import { IExpenses } from 'src/app/shared/interfaces/expenses/iexpenses';
import { loadExpensesSuccess, saveExpensesSuccess } from './expenses.actions';

export interface IExpensesState {
  lista: IExpenses[];
}

const initialState: IExpensesState = {
  lista: [
    {
      id: 1,
      name: 'string1',
      expenseType: 1,
    },

    {
      id: 2,
      name: 'string2',
      expenseType: 1,
    },
    {
      id: 3,
      name: 'string3',
      expenseType: 2,
    },
  ],
};

export const expensesReducer = createReducer(
  initialState,
  on(loadExpensesSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
  })),

  on(saveExpensesSuccess, (state, { expenses }) => ({
    ...state,
    lista: [...state.lista, expenses],
  }))
);
